<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="purchaseItemHeader"
      :items="purchaseItems"
      :search="search"
      hide-default-footer
      disable-pagination
    />
  </v-card>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {
   name: 'IncomingIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Bestell Artikel',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      purchaseItems: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         search: '',
         purchaseItemHeader: [
            { text: 'Name', value: 'name' },
            { text: 'Lagermenge', value: 'amount' },
            { text: 'Soll Menge', value: 'minStock' }
         ]
      }
   }
}
</script>

<style>

</style>
